import { render, staticRenderFns } from "./MixArticleContainer.vue?vue&type=template&id=c0c0c912&"
import script from "./MixArticleContainer.vue?vue&type=script&lang=js&"
export * from "./MixArticleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports